import {ViewName} from "@kta20-core/interfaces/view-name";
import {ViewNames} from "@kta20-ui-base/constants";

export const ModuleViews: ViewName[] = [
    {
        name: ViewNames.SINGLE_NAV_LAYOUT_VIEW,
        loader: async () => { await import(`@kta20-ui-base/view/single-nav-layout-view/single-nav-layout-view`); },
        loaded: false
    }
];
